module.exports = __webpack_public_path__ + "static/media/sohan.a5111cf9.jpg";